/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Failedtopicsubscribe2Inputs */

const id_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal berlangganan ke topik`)
};

const ms_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal melanggan topik`)
};

const da_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke abonnere på emne`)
};

const de_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnieren des Themas fehlgeschlagen`)
};

const en_us2_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to subscribe to topic`)
};

const es_es2_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al suscribirse al tema`)
};

const es_mx2_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al suscribirse al tema`)
};

const fil_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabigong mag-subscribe sa paksa`)
};

const fr_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'abonnement au sujet`)
};

const it_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile iscriversi all'argomento`)
};

const hu_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sikertelen feliratkozás a témára`)
};

const nl_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonneren op onderwerp mislukt`)
};

const no_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke abonnere på emne`)
};

const pl_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się subskrybować tematu`)
};

const pt_br2_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to subscribe to topic`)
};

const pt_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao subscrever tópico`)
};

const ro_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonarea la subiect a eșuat`)
};

const fi_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aiheen tilaus epäonnistui`)
};

const sv_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misslyckades att prenumerera på ämne`)
};

const vi_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký chủ đề thất bại`)
};

const tr_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konuya abone olunamadı`)
};

const cs_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepodařilo se přihlásit k tématu`)
};

const bg_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неуспешно абониране за тема`)
};

const ru_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось подписаться на тему`)
};

const uk_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося підписатися на тему`)
};

const ar_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل الاشتراك في الموضوع`)
};

const hi_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विषय की सदस्यता लेने में विफल`)
};

const th_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครรับหัวข้อไม่สำเร็จ`)
};

const ja_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トピックの購読に失敗しました`)
};

const zh_cn2_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to subscribe to topic`)
};

const zh_hant1_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to subscribe to topic`)
};

const ko_notifications_simple_failedtopicsubscribe2 = /** @type {(inputs: Notifications_Simple_Failedtopicsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to subscribe to topic`)
};

/**
* | output |
* | --- |
* | "Failed to subscribe to topic" |
*
* @param {Notifications_Simple_Failedtopicsubscribe2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_failedtopicsubscribe2 = /** @type {((inputs?: Notifications_Simple_Failedtopicsubscribe2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Failedtopicsubscribe2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "ms") return ms_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "da") return da_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "de") return de_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "fil") return fil_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "fr") return fr_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "it") return it_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "hu") return hu_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "nl") return nl_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "no") return no_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "pl") return pl_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "pt") return pt_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "ro") return ro_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "fi") return fi_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "sv") return sv_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "vi") return vi_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "tr") return tr_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "cs") return cs_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "bg") return bg_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "ru") return ru_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "uk") return uk_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "ar") return ar_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "hi") return hi_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "th") return th_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "ja") return ja_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_failedtopicsubscribe2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_failedtopicsubscribe2(inputs)
	return ko_notifications_simple_failedtopicsubscribe2(inputs)
});
export { notifications_simple_failedtopicsubscribe2 as "notifications.simple.failedTopicSubscribe" }